var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoticeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Notice"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glyph"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9007 6.60445C20.1627 6.34038 20.5946 6.35062 20.8362 6.63107C23.7205 9.98624 23.7205 14.9811 20.8362 18.3363C20.5946 18.6167 20.1647 18.6249 19.9027 18.3649C19.6632 18.1254 19.655 17.7447 19.8761 17.4867C22.3326 14.6167 22.3305 10.3527 19.8761 7.48265C19.655 7.22267 19.6611 6.84396 19.9007 6.60445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.2139 8.28913C18.4841 8.01892 18.9304 8.04553 19.1699 8.34236C21.1064 10.7497 21.1064 14.2113 19.1699 16.6208C18.9304 16.9196 18.4841 16.9442 18.2139 16.674C17.9846 16.4447 17.9559 16.0783 18.1606 15.8285C19.7349 13.8838 19.7349 11.0793 18.1606 9.13662C17.958 8.88483 17.9866 8.51841 18.2139 8.28913Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.92221 12.4816C6.92221 14.1151 5.5957 15.4416 3.96213 15.4416C2.32651 15.4437 1 14.1151 1 12.4816C1 10.8459 2.32651 9.52148 3.96213 9.52148C5.5957 9.52148 6.92221 10.8459 6.92221 12.4816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.2109 16.2031C11.2109 17.0915 10.4903 17.8121 9.60189 17.8121H5.83526C4.94887 17.8121 4.23035 17.0936 4.23035 16.2031V8.75989C4.23035 7.87145 4.94887 7.15088 5.83526 7.15088H9.60189C10.4903 7.15088 11.2109 7.87145 11.2109 8.75989V16.2031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.348 4.20934C14.9529 3.89204 14.2447 3.97597 13.9233 4.19296L9.55888 7.151H8.58447V17.8122H9.56298L13.8004 20.6843C14.3265 20.9627 14.8711 20.7928 15.2866 20.543C15.6899 20.2994 15.8168 19.8368 15.8168 19.6218V5.13053C15.8168 4.90739 15.7206 4.49388 15.348 4.20934Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeIcon);
export default __webpack_public_path__ + "static/media/notice_icon.7ca9448d3fc97ff4a680fc9c72f49b51.svg";
export { ForwardRef as ReactComponent };